<template>
    <div>

        <!-- 功能 -->
        <div class="header-menu">
            <el-form :inline="true" label-width="100px">
            <el-form-item label="提交人">
                <el-select class="select" filterable clearable v-model="fromData.creatorId" placeholder="请选择老师名称"
                style="width:100%;">
                <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                    :label="teacher.realname" :value="teacher.id">
                </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="审批状态">
                <el-select placeholder="请选择科目" v-model="fromData.approvalStatus" style="width: 100%" clearable filterable>
                <el-option v-for="item in optionList4" :key="item.value" :value="item.value"
                    :label="item.text"></el-option>
                </el-select>
            </el-form-item>
            <el-row>

                <el-col :span="12" :push="12" style="text-align: right;">
                <el-button type="primary"  @click="searchStudent" size="small"
                    class="btns">查询</el-button>
                    <el-button type="primary" @click="handleClearList" class="btns" size="small" >清除</el-button>
                    <el-button type="primary" @click="handleApprover" class="btns" size="small">添加审批人</el-button>
                </el-col>
            </el-row>
            </el-form>
        </div>


      <div style="margin-top: 20px;">
        <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
            fixed
            prop="file"
            label="文件名称"
            width="150">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.file.fileName ? scope.row.file.fileName :''}}</span> -->
              <span>{{ (scope.row.file && scope.row.file.fileName ) ? scope.row.file.fileName : '' }}</span>
            </template>
            </el-table-column> 
            <el-table-column
            prop="file"
            label="文件所在目录"
            >
            <template slot-scope="scope">
              <span>{{ (scope.row.file && scope.row.file.folderName ) ? scope.row.file.folderName : ''}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="approvalPersonId"
            label="文件内容"
            width="80">
            <template slot-scope="scope">
              <span style="color:#409EFF"  @click="handleClickDep(scope.row)">详情</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="file"
            label="提交人"
            width="100">
            <template slot-scope="scope">
              <span>{{ (scope.row.file && scope.row.file.creatorName ) ? scope.row.file.creatorName : ''}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="approvalStatus"
            label="审批结果">
            <template slot-scope="scope">
              <span v-if="scope.row.approvalStatus === 0" style="color: #E6A23C;">未审批</span>
              <span v-if="scope.row.approvalStatus === 1" style="color: limegreen;">已审批</span>
              <span v-if="scope.row.approvalStatus === 2" style="color: red;">驳回</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="file"
            label="上传时间">
            <template slot-scope="scope">
              <span>{{ (scope.row.file && scope.row.file.createTime ) ? scope.row.file.createTime : ''}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="approvalTime"
            label="审批时间">
            </el-table-column>
            <el-table-column
            prop="approvalOpinion"
            label="审批详情">
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
                <el-button  type="text" size="small" v-if="scope.row.approvalStatus !== 0">已审批</el-button>
                <el-button @click="handleClick(scope.row)" type="text" size="small" v-else>审批</el-button>
            </template>
            </el-table-column>
        </el-table>
      </div>


      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="fromData.pageNo"
        :page-size="fromData.pageSize"
        :total="fromData.allTotal"
        layout="prev, pager, next,sizes,jumper">
    </el-pagination>


    <!-- 审批弹窗 -->
    <el-dialog
      title="提示"
      append-to-body
      :visible.sync="dialogVisibles"
      width="40%"
      :before-close="handledialogVisibles"                                                       >
     <el-form>
           <el-form-item
              label="上传审批"
              label-width="100px"
              >
                <el-radio-group v-model="approverType">
                  <el-radio :label="1">通过</el-radio>
                  <el-radio :label="2">驳回</el-radio>
                </el-radio-group>
                <!-- <el-select v-model="approverType" filterable clearable placeholder="请选择状态">
                  <el-option label="审批通过" value="1"></el-option>
                  <el-option label="审批驳回" value="2"></el-option>
                </el-select> -->
           </el-form-item>
        <el-form-item label="审批意见" v-if="approverType === 2">
            <el-input v-model="commitRemark1"  type="textarea"  placeholder="请输入审批意见" maxlength="300" show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibles = false, commitRemark1 = '', approverType = 1 ">取 消</el-button>
        <el-button type="primary" @click="sbmitapprover">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择审批人 -->
    <el-dialog
      title="提示"
      append-to-body
      :visible.sync="dialogApprover"
      width="40%"
      :before-close="handledialogApprover"                                                       >
     <el-form>
           <el-form-item label="审批人" label-width="100px">
                      <el-select
                        style="width: 100%"
                        v-model="Approverpepu"
                        multiple
                        placeholder="请选择"
                        filterable
                      >
                        <el-option
                          style="margin-left: 10px"
                          v-for="item in ApproverpepuList"
                          :key="item.id"
                          :label="item.realname"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
           </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogApprover = false, Approverpepu =[]">取 消</el-button>
        <el-button type="primary" @click="okTouch">确 定</el-button>
      </span>
    </el-dialog>



    
    <el-dialog title="预览图片" width="50%" style="padding: 0px 50px;" :visible.sync="showInfo" :before-close="showshowInfoViewInfoCler" :close-on-click-modal="false">
      <Guciya v-if="showInfo" :url="urls" ></Guciya>
    </el-dialog>

    <el-dialog title="预览" width="60%" style="padding: 0px 50px;" :visible.sync="showImgDing" :before-close="showImgDingClers5" :close-on-click-modal="false">
        <div style="margin-bottom: 20px;">
            <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload1" class="mr10"> 下 载</el-button> -->
        </div>
        <div>
            <img :src="showImgDingurlsss" :alt="showImgDingurlsss" style="width: 100%;">
        </div>
    </el-dialog>

    <el-dialog title="预览" width="60%" style="padding: 0px 50px;" :visible.sync="showInfos" :before-close="showshowInfoViewInfoClers" :close-on-click-modal="false">
        <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下 载</el-button> -->
        <!-- <el-button :theme="'default'"  type="submit" :title="'基础按钮'"  class="mr10">暂无预览~</el-button> -->
        <GuciYa-VueOfficeDocx :src="docxContent" ref="docxEditor" :options="editorOptions"></GuciYa-VueOfficeDocx>
    </el-dialog>
        
      
    </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { getSubject,} from "@/api/firstClassApi";

import Guciya from "../InterviewManagement/components/Guciya-compoents";

export default {
  components: { Guciya },
  name: "fileManagement",
  props: {  },
  data(){
    return {
        dialogApprover:false,
        approverType:1,
        dialogVisibles:false,
        commitRemark1:'',
        teachers:[],
        fromData:{
          creatorId:'',
          approvalStatus:'',
          pageNo:1,
          pageSize:10,
          totalPage:null,
          pageIndex:null,
          allTotal:null
        },
        optionList4:[
          {value:0, text:'待审批'},
          {value:1, text:'审批通过'},
          {value:2, text:'审批驳回'},
        ],

        tableData: [],
        approvalId:'',
        Approverpepu:[],
        ApproverpepuList:[],


        showInfo:false,
        urls:'',
        docxContent:'',
        showInfos:false,
        showImgDingurlsss:'',
        showImgDing:false,

        editorOptions: {
          toolbar: true,
          width: '800px',
          height: '600px'
        },
      };
  },
  mounted(){

    axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisList`, {
      headers: {
        'authorization': sessionStorage.getItem('tokenInfo')
      }
    }) // 请替换为你的API URL
      .then(response => {
        this.teachers = [...response.data.data]
      })
      .catch(error => {
        console.error(error);
    });

    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
        this.ApproverpepuList = res.data.data
    })

      this.getiApprovalRecordList()
 
  },
  methods:{

    getiApprovalRecordList(){
      let data = {
        creatorId:this.fromData.creatorId,
        approvalStatus:this.fromData.approvalStatus,
        pageNo:this.fromData.pageNo,
        pageSize:this.fromData.pageSize
      }
      axios.post(`${apiBaseUrl}/approvalRecord/list`,data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res)=>{     
        this.tableData = res.data.data.records
        this.fromData.allTotal = res.data.data.total 
      })
    },

    handleClick(row) {
        
        this.approvalId = row.approvalId
        this.dialogVisibles = true
    },
    searchStudent(){
      this.fromData.pageNo = 1
      this.getiApprovalRecordList()
    },
    handleClearList(){
      this.fromData = {
          creatorId:'',
          approvalStatus:'',
          pageNo:1,
          pageSize:10,
        }
        this.getiApprovalRecordList()
    },
    handledialogVisibles(){
      this.dialogVisibles = false
    },
    handledialogApprover(){
      this.dialogApprover = false
    },
    handleApprover(){
      this.dialogApprover = true
      // axios.get(`${apiBaseUrl}/approvalPerson/list/1`,{
      //   headers:{
      //     'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      // }).then((res)=>{
      //   if(res.data.code === 200){
      //     this.ApproverpepuList = res.data.data
      //       this.$message.success(res.data.message)
      //     }else{
      //       this.$message.error(res.data.message)

      //     }
      // })
    },
    okTouch(){
      let data = {
        adminList:this.Approverpepu,
        approvalType: 1
      } 
      axios.post(`${apiBaseUrl}/approvalPerson/add`,data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res)=>{
        if(res.data.code === 200){
          this.dialogApprover = false
            this.$message.success(res.data.message)
          }else{
            this.dialogApprover = false
            this.$message.error(res.data.message)

          }
      })
    },
    sbmitapprover(){
      if(this.approverType === 1){
        let data = {
          approvalId:this.approvalId,
          callerType:1,
        }
        axios.post(`${apiBaseUrl}/approvalRecord/approve`,data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
            }
        }).then((res)=>{
          if(res.data.code === 200){
            this.getiApprovalRecordList()
            this.$message.success(res.data.message)
          }else{
            this.$message.error(res.data.message)

          }
          this.dialogVisibles = false
          this.getiApprovalRecordList()
        })
      }else if(this.approverType === 2){
        if(this.commitRemark1 === ''){
          this.$message({
            message: "请填写驳回原因！！！",
            type: "error",
            duration: 1000
        });
        }else{
          let data = {
            approvalOpinion:this.commitRemark1,
            approvalId:this.approvalId,
            callerType:1,
          }
          axios.post(`${apiBaseUrl}/approvalRecord/reject`,data,{
            headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
            }
          }).then((res)=>{
            if(res.data.code === 200){
              this.getiApprovalRecordList()
              this.$message.success(res.data.message)
            }else{
              this.$message.error(res.data.message)

            }
            this.dialogVisibles =false
            this.getiApprovalRecordList()
          })
        }
       
      }
    },

  upgradeToHttps(urlString) {
    const hasHttps = urlString.includes('https://');

    if (!hasHttps && urlString.includes('http://')) {
      return urlString.replace('http://', 'https://');
    } else {
      return urlString;
    }
  },
  
  issoN(str){
        try {
            JSON.parse(str)
            return true
        } catch(e){
            return false
        }
  },

  handleClickDep(row){
    const replacedString = row.file.fileUrl.replace('+', '%2B')
      const replacedStrings = this.upgradeToHttps(replacedString)
      row.file.fileUrl = replacedStrings


          if(this.issoN(row.file.fileUrl)){


            let JsonUrls = JSON.parse(row.file.fileUrl)
            let JsonUrl = ''
            if(JsonUrls && Array.isArray(JsonUrls)){
                JsonUrl = JsonUrls[0].url
            }else{
                JsonUrl = JsonUrls.url
            }

            if(JsonUrl){
              if(this.getFileName(JsonUrl) === ".pdf"){
                    this.urls = JsonUrl
                    this.showInfo = true
                }else if (this.getFileName(JsonUrl) === ".docx" || this.getFileName(JsonUrl) === ".doc"){
                    this.docxContent = JsonUrl
                    this.showInfos = true
                }else{
                    if(this.getFileName(JsonUrl) === ".jpg" || this.getFileName(JsonUrl) === ".png"){
                        this.showImgDingurlsss = JsonUrl
                        this.showImgDing = true
                    }
                    else{
                        this.$message({type: 'warning', message: '请检查是否为有效的文件类型~' })
                    }
                }
            }

          }else{
            if(row.file.fileUrl){
              if(this.getFileName(row.file.fileUrl) === ".pdf"){
                    this.urls = row.file.fileUrl
                    this.showInfo = true
                }else if (this.getFileName(row.file.fileUrl) === ".docx" || this.getFileName(row.file.fileUrl) === ".doc"){
                    this.docxContent = row.file.fileUrl
                    this.showInfos = true
                }else{
                    if(this.getFileName(row.file.fileUrl) === ".jpg" || this.getFileName(row.file.fileUrl) === ".png"){
                        this.showImgDingurlsss = row.file.fileUrl
                        this.showImgDing = true
                    }
                    else{
                        this.$message({type: 'warning', message: '请检查是否为有效的文件类型~' })
                    }
                }
            }
          }
      
  },
  getFileName(name) { return name.substring(name.lastIndexOf("."))},
  showshowInfoViewInfoCler(){
      this.showInfo = false
  },
  showImgDingClers5(){
      this.showImgDing = false
      this.showImgDingurlsss = ''
  },
  showshowInfoViewInfoClers(){
        this.showInfos = false
  },
  handleSizeChange(size){
    
          this.fromData.pageSize = size
          this.getiApprovalRecordList()
  },

  handleCurrentChange(size){
          this.fromData.pageNo = size
          this.getiApprovalRecordList()
  },
  },
 
}

</script>


<style lang="less" scoped>



</style>



// WEBPACK FOOTER //
// src/FileSpace/fileManagement.vue